import ReviewProcessLayout from '../components/layouts/ReviewProcessLayout.vue';
import ReviewProcessIndexPage from '../pages/ReviewProcessIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
    {
        // This is the parent route for your package.
        // It uses the layout component.
        path: '/review-process',
        name: 'review-process.root',
        component: ReviewProcessLayout,
        meta: {
            // e.g., requiresAuth: true
            // requiresAuth: true,
            // title: 'reviewProcess.nav.title',
            // layout: 'Authenticated',
        },
        // All other package routes are children of this layout
        children: [
            {
                // Child path is empty, so it renders at /review-process
                path: '',
                name: 'ReviewProcessIndexPage',
                component: ReviewProcessIndexPage,
            },
            // --- Example of other child routes ---
            // {
            //   path: 'create', // Renders at /review-process/create
            //   name: 'review-process.create',
            //   component: () => import('../components/Create.vue'),
            // },
        ]
    }
];
